import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import ModalActionButton from '../../elements/ModalActionButton';
import { updateStaff } from '../../../store/actions/staffActions';
import RadioGroup from '../../elements/form/RadioGroup';
const UpdateStaffEmploymentType = ({ staff, currentEmploymentType, close }) => {
    const staffSelector = useSelector(state => state.staff);
    const dispatch = useDispatch();
    const [selectedEmploymentType, setSelectedEmploymentType] = React.useState(currentEmploymentType); 
    const updateStaffEmploymentType = () => {
        const payload = {
            employmentType: selectedEmploymentType
        };
        dispatch(updateStaff(staff?._id, payload));
    };

    const employmentTypeOptions = [
        {
            label: 'Full-Time',
            value: 'FULL_TIME',
        },
        {
            label: 'Part-Time',
            value: 'PART_TIME',
        },
        {
            label: 'Contract',
            value: 'CONTRACT',
        }
    ]
    return (
        <div className="w-full">
            <div className='mt-4'>
                <RadioGroup 
                    items={employmentTypeOptions} 
                    inline={true}
                    preSelectedIndex={employmentTypeOptions.findIndex(item => item.value === selectedEmploymentType.value)}
                    inputLabel={'Employment Type'}
                    requiredField={true}
                    returnSelected={(value) => {setSelectedEmploymentType(value.value)}} 
                    hasError={false}  
                    titleField='label'
                />
            </div>
            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update Employment Type for ${staff?.name || 'Staff'}`}
                    buttonAction={updateStaffEmploymentType}
                    processing={staffSelector.updatingStaff}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent transition duration-200 hover:bg-opacity-5 rounded-xl hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
            
            </div>
        </div>
    )
}

export default UpdateStaffEmploymentType